const actions = {
    CONTACT_SET_TYPES: "CONTACT_SET_TYPES",
    CREATE_CONTACT_REQUEST: "CREATE_CONTACT_REQUEST",
    CREATE_CONTACT_SUCCESS: "CREATE_CONTACT_SUCCESS",
    IMPORT_CONTACTS_REQUEST: "IMPORT_CONTACTS_REQUEST",
    IMPORT_CONTACTS_SUCCESS: "IMPORT_CONTACTS_SUCCESS",
    IMPORT_CONTACTS_ERROR: "IMPORT_CONTACTS_ERROR",
    BULK_UPDATE_CONTACTS_REQUEST: "BULK_UPDATE_CONTACTS_REQUEST",
    BULK_UPDATE_CONTACTS_SUCCESS: "BULK_UPDATE_CONTACTS_SUCCESS",
    BULK_UPDATE_CONTACTS_ERROR: "BULK_UPDATE_CONTACTS_ERROR",
    BULK_DELETE_CONTACTS_REQUEST: "BULK_DELETE_CONTACTS_REQUEST",
    BULK_DELETE_CONTACTS_SUCCESS: "BULK_DELETE_CONTACTS_SUCCESS",
    BULK_DELETE_CONTACTS_ERROR: "BULK_DELETE_CONTACTS_ERROR",
    READ_BULK_CONTACTS_REQUEST: "READ_BULK_CONTACTS_REQUEST",
    READ_BULK_CONTACTS_SUCCESS: "READ_BULK_CONTACTS_SUCCESS",
    READ_BULK_CONTACTS_ERROR: "READ_BULK_CONTACTS_ERROR",
    READ_CONTACTS_REQUEST: "READ_CONTACTS_REQUEST",
    READ_CONTACTS_SUCCESS: "READ_CONTACTS_SUCCESS",
    READ_CONTACTS_ERROR: "READ_CONTACTS_ERROR",
    CREATE_CONTACT_ERROR: "CREATE_CONTACT_ERROR",
    READ_CONTACT_REQUEST: "READ_CONTACT_REQUEST",
    READ_CONTACT_SUCCESS: "READ_CONTACT_SUCCESS",
    READ_CONTACT_ERROR: "READ_CONTACT_ERROR",
    READ_CONTACT_STATEMENT_REQUEST: "READ_CONTACT_STATEMENT_REQUEST",
    READ_CONTACT_STATEMENT_SUCCESS: "READ_CONTACT_STATEMENT_SUCCESS",
    READ_CONTACT_STATEMENT_ERROR: "READ_CONTACT_STATEMENT_ERROR",
    UPDATE_CONTACT_REQUEST: "UPDATE_CONTACT_REQUEST",
    UPDATE_CONTACT_SUCCESS: "UPDATE_CONTACT_SUCCESS",
    UPDATE_CONTACT_ERROR: "UPDATE_CONTACT_ERROR",
    UPDATE_CONTACT_MYINVOIS_FORM_FIELD: "UPDATE_CONTACT_MYINVOIS_FORM_FIELD",
    ARCHIVE_CONTACT_REQUEST: "ARCHIVE_CONTACT_REQUEST",
    ARCHIVE_CONTACT_SUCCESS: "ARCHIVE_CONTACT_SUCCESS",
    ARCHIVE_CONTACT_ERROR: "ARCHIVE_CONTACT_ERROR",
    DELETE_CONTACT_REQUEST: "DELETE_CONTACT_REQUEST",
    DELETE_CONTACT_SUCCESS: "DELETE_CONTACT_SUCCESS",
    DELETE_CONTACT_ERROR: "DELETE_CONTACT_ERROR",
    CHANGE_CONTACT: "CHANGE_CONTACT",
    RESET_CONTACT_STATE: "RESET_CONTACT_STATE",
    SEND_EMAIL_STATEMENT_REQUEST: "SEND_EMAIL_STATEMENT_REQUEST",
    SEND_EMAIL_STATEMENT_SUCCESS: "SEND_EMAIL_STATEMENT_SUCCESS",
    SEND_EMAIL_STATEMENT_ERROR: "SEND_EMAIL_STATEMENT_ERROR",
    CONTACT_ADD_FILE: "CONTACT_ADD_FILE",
    CONTACT_SET_FILE: "CONTACT_SET_FILE",
    CONTACT_SET_FILES: "CONTACT_SET_FILES",
    CONTACT_REMOVE_FILE: "CONTACT_REMOVE_FILE",
    EXPORT_STATEMENT_REQUEST: "EXPORT_STATEMENT_REQUEST",
    EXPORT_STATEMENT_SUCCESS: "EXPORT_STATEMENT_SUCCESS",
    EXPORT_STATEMENT_ERROR: "EXPORT_STATEMENT_ERROR",
    GET_STATEMENT_LINK_REQUEST: "GET_STATEMENT_LINK_REQUEST",
    GET_STATEMENT_LINK_SUCCESS: "GET_STATEMENT_LINK_SUCCESS",
    GET_STATEMENT_LINK_ERROR: "GET_STATEMENT_LINK_ERROR",
    CREATE_PDFS_REQUEST: "CREATE_PDFS_REQUEST",
    CREATE_PDFS_SUCCESS: "CREATE_PDFS_SUCCESS",
    CREATE_PDFS_ERROR: "CREATE_PDFS_ERROR",
    SEND_BULK_EMAIL_STATEMENT_REQUEST: "SEND_BULK_EMAIL_STATEMENT_REQUEST",
    SEND_BULK_EMAIL_STATEMENT_SUCCESS: "SEND_BULK_EMAIL_STATEMENT_SUCCESS",
    SEND_BULK_EMAIL_STATEMENT_ERROR: "SEND_BULK_EMAIL_STATEMENT_ERROR",
    SET_CONTACT_STATEMENT_TYPE: "SET_CONTACT_STATEMENT_TYPE",
    CONTACTS_MERGE_REQUEST: "CONTACTS_MERGE_REQUEST",
    CONTACTS_MERGE_SUCCESS: "CONTACTS_MERGE_SUCCESS",
    CONTACTS_MERGE_ERROR: "CONTACTS_MERGE_ERROR",

    SEND_MYINVOIS_INFO_REQUEST: "SEND_MYINVOIS_INFO_REQUEST",
    SEND_MYINVOIS_INFO_SUCCESS: "SEND_MYINVOIS_INFO_SUCCESS",
    SEND_MYINVOIS_INFO_ERROR: "SEND_MYINVOIS_INFO_ERROR",

    GET_MYINVOIS_INFO_REQUEST: "GET_MYINVOIS_INFO_REQUEST",
    GET_MYINVOIS_INFO_SUCCESS: "GET_MYINVOIS_INFO_SUCCESS",
    GET_MYINVOIS_INFO_ERROR: "GET_MYINVOIS_INFO_ERROR",

    BULK_SEND_MYINVOIS_INFO_REQUEST: "BULK_SEND_MYINVOIS_INFO_REQUEST",
    BULK_SEND_MYINVOIS_INFO_SUCCESS: "BULK_SEND_MYINVOIS_INFO_SUCCESS",
    BULK_SEND_MYINVOIS_INFO_ERROR: "BULK_SEND_MYINVOIS_INFO_ERROR",

    // MANDATES
    TOGGLE_MANDATE_MODAL: "TOGGLE_MANDATE_MODAL",
    TOGGLE_MANDATE_DRAWER: "TOGGLE_MANDATE_DRAWER",
    GET_MANDATES_REQUEST: "GET_MANDATES_REQUEST",
    GET_MANDATES_SUCCESS: "GET_MANDATES_SUCCESS",
    GET_MANDATES_ERROR: "GET_MANDATES_ERROR",
    READ_CONTACT_MANDATE_REQUEST: "READ_CONTACT_MANDATE_REQUEST",
    READ_CONTACT_MANDATE_SUCCESS: "READ_CONTACT_MANDATE_SUCCESS",
    READ_CONTACT_MANDATE_ERROR: "READ_CONTACT_MANDATE_ERROR",
    CREATE_CONTACT_MANDATE_REQUEST: "CREATE_CONTACT_MANDATE_REQUEST",
    CREATE_CONTACT_MANDATE_SUCCESS: "CREATE_CONTACT_MANDATE_SUCCESS",
    CREATE_CONTACT_MANDATE_ERROR: "CREATE_CONTACT_MANDATE_ERROR",
    UPDATE_CONTACT_MANDATE_REQUEST: "UPDATE_CONTACT_MANDATE_REQUEST",
    UPDATE_CONTACT_MANDATE_SUCCESS: "UPDATE_CONTACT_MANDATE_SUCCESS",
    UPDATE_CONTACT_MANDATE_ERROR: "UPDATE_CONTACT_MANDATE_ERROR",
    DELETE_CONTACT_MANDATE_REQUEST: "DELETE_CONTACT_MANDATE_REQUEST",
    DELETE_CONTACT_MANDATE_SUCCESS: "DELETE_CONTACT_MANDATE_SUCCESS",
    DELETE_CONTACT_MANDATE_ERROR: "DELETE_CONTACT_MANDATE_ERROR",

    CONTACT_SET_TABLE_IDS: "CONTACT_SET_TABLE_IDS",

    ADD_ADDRESS: "CONTACT_ADD_ADDRESS",
    SET_ALL_ADDRESS: "CONTACT_SET_ALL_ADDRESS",
    DELETE_ADDRESS: "CONTACT_DELETE_ADDRESS",
    RESET_ALL_ADDRESS: "RESET_ALL_ADDRESS",

    ADD_CONTACT_PERSON: "CONTACT_ADD_CONTACT_PERSON",
    SET_ALL_CONTACT_PERSON: "CONTACT_SET_ALL_CONTACT_PERSON",
    REMOVE_CONTACT_PERSON: "CONTACT_REMOVE_CONTACT_PERSON",
    RESET_ALL_CONTACT_PERSON: "RESET_ALL_CONTACT_PERSON",

    // used in ContactPersonInput AutoComplete component
    SET_BILLING_CONTACT_PERSON_ID: "SET_BILLING_CONTACT_PERSON_ID",
    SET_SHIPPING_CONTACT_PERSON_ID: "SET_SHIPPING_CONTACT_PERSON_ID",

    SET_CONTACT_MYINVOIS_FIELD: "SET_CONTACT_MYINVOIS_FIELD",
    SET_CONTACT_MYINVOIS_FIELDS: "SET_CONTACT_MYINVOIS_FIELDS",
    SET_CONTACT_MYINVOIS_ADDRESSS_FIELD: "SET_CONTACT_MYINVOIS_ADDRESSS_FIELD",
    RESET_CONTACT_MYINVOIS_ADDRESS_FIELDS:
    "RESET_CONTACT_MYINVOIS_ADDRESS_FIELDS",

    SEARCH_CONTACT_TIN_REQUEST: "SEARCH_CONTACT_TIN_REQUEST",
    SEARCH_CONTACT_TIN_SUCCESS: "SEARCH_CONTACT_TIN_SUCCESS",
    SEARCH_CONTACT_TIN_ERROR: "SEARCH_CONTACT_TIN_ERROR",
    GET_CONTACT_CODE_REQUEST: "GET_CONTACT_CODE_REQUEST",
    GET_CONTACT_CODE_SUCCESS: "GET_CONTACT_CODE_SUCCESS",
    GET_CONTACT_CODE_ERROR: "GET_CONTACT_CODE_ERROR",

    // used in incoming document to set supplier name and tin
    SET_CONTACT_FIELD: "SET_CONTACT_DETAILS",

    SET_CONTACT_ID: "SET_CONTACT_ID",

    // used in batch import, to know which row is the first contact row in the xlsx after deducting the header rows
    SET_IMPORT_HEADER_ROW_LINE_COUNT: "SET_IMPORT_HEADER_ROW_LINE_COUNT",

    setTypes: types => ({
        type: actions.CONTACT_SET_TYPES,
        types,
    }),
    createContact: request => ({
        type: actions.CREATE_CONTACT_REQUEST,
        request,
    }),
    importContacts: request => ({
        type: actions.IMPORT_CONTACTS_REQUEST,
        request,
    }),
    bulkUpdateContacts: request => ({
        type: actions.BULK_UPDATE_CONTACTS_REQUEST,
        request,
    }),
    bulkDeleteContacts: request => ({
        type: actions.BULK_DELETE_CONTACTS_REQUEST,
        request,
    }),
    readBulkContacts: request => ({
        type: actions.READ_BULK_CONTACTS_REQUEST,
        request,
    }),
    readContacts: request => ({
        type: actions.READ_CONTACTS_REQUEST,
        request,
    }),
    readContact: (id, forceHideFilePreview) => ({
        type: actions.READ_CONTACT_REQUEST,
        id,
        forceHideFilePreview,
    }),
    readContactStatement: (id, request) => ({
        type: actions.READ_CONTACT_STATEMENT_REQUEST,
        id,
        request,
    }),
    updateContact: (id, request) => ({
        type: actions.UPDATE_CONTACT_REQUEST,
        id,
        request,
    }),
    updateContactMyInvoisFormField: (field, value) => ({
        type: actions.UPDATE_CONTACT_MYINVOIS_FORM_FIELD,
        field,
        value,
    }),
    archiveContact: (id, request) => ({
        type: actions.ARCHIVE_CONTACT_REQUEST,
        id,
        request,
    }),
    deleteContact: id => ({
        type: actions.DELETE_CONTACT_REQUEST,
        id,
    }),
    changeContact: (request, reset = false) => ({
        type: actions.CHANGE_CONTACT,
        request,
        reset,
    }),
    resetContactState: () => ({
        type: actions.RESET_CONTACT_STATE,
    }),
    sendEmailStatement: (id, request) => ({
        type: actions.SEND_EMAIL_STATEMENT_REQUEST,
        id,
        request,
    }),
    addFile: file => ({
        type: actions.CONTACT_ADD_FILE,
        file,
    }),
    setFile: file => ({
        type: actions.CONTACT_SET_FILE,
        file,
    }),
    setFiles: files => ({
        type: actions.CONTACT_SET_FILES,
        files,
    }),
    removeFile: fileId => ({
        type: actions.CONTACT_REMOVE_FILE,
        fileId,
    }),

    exportStatement: (id, exportType, request) => ({
        type: actions.EXPORT_STATEMENT_REQUEST,
        id, // contact_id: int
        exportType, // 'pdf' or 'xls'
        request, // { 'date_from': YYYY-MM-DD, 'date_to': YYYY-MM-DD, 'remarks': String}
    }),

    getStatementLink: (id, request) => ({
        type: actions.GET_STATEMENT_LINK_REQUEST,
        id, // contact_id: int
        request, // { 'date_from': YYYY-MM-DD, 'date_to': YYYY-MM-DD, 'remarks': String}
    }),

    createPdfs: request => ({
        type: actions.CREATE_PDFS_REQUEST,
        request,
    // request: { [contact_ids:int], 'date_from': YYYY-MM-DD, 'date_to': YYYY-MM-DD, 'remarks': String}
    }),
    sendBulkEmailStatement: request => ({
        type: actions.SEND_BULK_EMAIL_STATEMENT_REQUEST,
        request,
    // request: {
    //     [contact_ids:int],
    //     'date_from': YYYY-MM-DD,
    //     'date_to': YYYY-MM-DD,
    //     'remarks': String,
    //     'subject': String,
    //     'message': String
    // }
    }),
    setStatementType: statementType => ({
        type: actions.SET_CONTACT_STATEMENT_TYPE,
        statementType, // 'DEBTOR' OR 'CREDITOR'
    }),

    mergeContacts: request => ({
        type: actions.CONTACTS_MERGE_REQUEST,
        request, // { contact_ids: [1,2,3], target_contact_id: 1}
    }),

    sendMyInvoisEmail: (id, emails) => ({
        type: actions.SEND_MYINVOIS_INFO_REQUEST,
        id,
        emails,
    }),

    getMyInvoisRequestUrl: id => ({
        type: actions.GET_MYINVOIS_INFO_REQUEST,
        id,
    }),

    bulkSendMyInvoisEmail: request => ({
        type: actions.BULK_SEND_MYINVOIS_INFO_REQUEST,
        request,
    }),

    toggleMandateModal: (visible, overrideContact) => ({
        type: actions.TOGGLE_MANDATE_MODAL,
        visible,
        overrideContact,
    }),
    toggleMandateDrawer: (visible, mode = "create", overrideContact = null) => ({
        type: actions.TOGGLE_MANDATE_DRAWER,
        visible,
        mode,
        overrideContact,
    }),
    getMandates: request => ({
        type: actions.GET_MANDATES_REQUEST,
        request, //
    }),
    readContactMandate: (id, request) => ({
        type: actions.READ_CONTACT_MANDATE_REQUEST,
        id,
        request, //
    }),
    createContactMandate: (id, request) => ({
        type: actions.CREATE_CONTACT_MANDATE_REQUEST,
        id,
        request, // name, email, effective_date, expiry_date, buffer_days,max_amount, frequency,
    }),
    updateContactMandate: (id, request) => ({
        type: actions.UPDATE_CONTACT_MANDATE_REQUEST,
        id,
        request, // {buffer_days, ...}
    }),
    deleteContactMandate: id => ({
        type: actions.DELETE_CONTACT_MANDATE_REQUEST,
        id,
    }),

    setContactTableIds: ids => ({
        type: actions.CONTACT_SET_TABLE_IDS,
        ids,
    }),

    addAddress: () => ({
        type: actions.ADD_ADDRESS,
    }),

    setAllAddress: addresses => ({
        type: actions.SET_ALL_ADDRESS,
        addresses,
    }),

    deleteAddress: key => ({
        type: actions.DELETE_ADDRESS,
        key,
    }),
    resetAddresses: () => ({
        type: actions.RESET_ALL_ADDRESS,
    }),

    addContactPerson: () => ({
        type: actions.ADD_CONTACT_PERSON,
    }),

    setAllContactPerson: contactPersons => ({
        type: actions.SET_ALL_CONTACT_PERSON,
        contactPersons,
    }),

    removeContactPerson: key => ({
        type: actions.REMOVE_CONTACT_PERSON,
        key,
    }),
    resetContactPersons: () => ({
        type: actions.RESET_ALL_CONTACT_PERSON,
    }),

    setBillingContactPersonId: id => ({
        type: actions.SET_BILLING_CONTACT_PERSON_ID,
        id,
    }),

    setShippingContactPersonId: id => ({
        type: actions.SET_SHIPPING_CONTACT_PERSON_ID,
        id,
    }),

    setContactMyInvoisField: (key, value) => ({
        type: actions.SET_CONTACT_MYINVOIS_FIELD,
        key,
        value,
    }),
    setContactMyInvoisFields: updatedValues => ({
        type: actions.SET_CONTACT_MYINVOIS_FIELDS,
        updatedValues,
    }),
    setContactMyInvoisAddressField: (key, value) => ({
        type: actions.SET_CONTACT_MYINVOIS_ADDRESSS_FIELD,
        key,
        value,
    }),
    // supply 'values' if you want to reset the fields with the given values
    resetContactMyInvoisAddressFields: (
        hasDefaultAddress = false,
        values = {},
    ) => ({
        type: actions.RESET_CONTACT_MYINVOIS_ADDRESS_FIELDS,
        hasDefaultAddress, // will be true if change from no default billing address to has default billing address
        values,
    }),

    searchContactTin: request => ({
        type: actions.SEARCH_CONTACT_TIN_REQUEST,
        request,
    }),
    getContactCode: request => ({
        type: actions.GET_CONTACT_CODE_REQUEST,
        request,
    }),

    // used in incoming document to set supplier name and tin
    setContactField: (key, value) => ({
        type: actions.SET_CONTACT_FIELD,
        key,
        value,
    }),

    setContactId: contactId => ({
        type: actions.SET_CONTACT_ID,
        contactId,
    }),

    setImportHeaderRowLineCount: headerRowLineCount => ({
        type: actions.SET_IMPORT_HEADER_ROW_LINE_COUNT,
        count: headerRowLineCount, // number of header rows in the xlsx file
    }),
};
export default actions;
